export { BrowserTracing } from './browsertracing';
export { instrumentOutgoingRequests, defaultRequestInstrumentationOptions, } from './request';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/tracing/esm/browser/index.js
// module id = 159
// module chunks = 0